export default {"src":"/login-app/[GIT_HASH]/_next/static/media/checklist.1ae4c008.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};